import Panel from "./Panel";
export { Panel };
export default Panel;
